const STEP_STATUSES = new Set(["done", "now", "next"]);
// isStepStatus — маркер пишет статус текстом; всё, кроме трёх известных значений, кит трактует
// как "next" (см. Steps() в service.jsx), поэтому неопознанное отдаём как undefined и не гадаем.
function isStepStatus(v) {
    return v !== undefined && STEP_STATUSES.has(v);
}
export function mapServiceSteps(steps, tFn) {
    if (!Array.isArray(steps) || steps.length === 0)
        return undefined;
    return steps.map((s) => {
        const key = s.label ? `service.step.${s.label}` : "";
        const translated = key ? tFn(key) : "";
        // t() без записи в словаре отдаёт сам КЛЮЧ (i18n.ts) — а не код шага; для незнакомого
        // кода нужен именно код (спека: «незнакомый код → сам код»), не служебный ключ словаря.
        return { id: s.id, label: translated === key ? (s.label ?? "") : translated, status: isStepStatus(s.status) ? s.status : undefined };
    });
}
